<div id="fastener-bse-point-select" cslPerfectScrollbar class="flex flex-col items-stretch flex-1">
  <div class="h-full flex flex-row gap-3 items-stretch">
    <div class="pr-3 control-panel-wrapper flex flex-col space-y-2 items-stretch basis-[400px]">
      <div class="fasteners-set-icon-wrapper flex flex-row justify-center items-center" *ngIf="hasImage()">
        <img class="fasteners-set-icon" src="{{ fastenersSetIconLink }}" alt="Fastener set icon" />
      </div>

      <mat-checkbox [(ngModel)]="hasMirroredHoles" (ngModelChange)="holeFormChanged(data)">
        <div class="flex flex-row flex-wrap gap-2 items-center">
          <div data-testid="addSymmetrically" i18n>Добавить симметрично по</div>
          <mat-form-field appearance="outline" class="micro-input no-subscript no-label">
            <mat-select
              data-testid="selectSymmetrically"
              [(ngModel)]="mirrorAxis"
              (ngModelChange)="holeFormChanged(data)"
              (click)="$event.stopPropagation(); $event.preventDefault()">
              <mat-option data-testid="selectSymmetricallyX" [value]="'x'">x</mat-option>
              <mat-option data-testid="selectSymmetricallyY" [value]="'y'">y</mat-option>
              <mat-option data-testid="selectSymmetricallyXY" [value]="'xy'">xy</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-checkbox>

      <ng-container
        *ngIf="
          isFastenersSet(fastener)
            ? fastener?.type !== thisPositioningTypeEnum.OnSide
            : fastener?.type === thisCustomHoleSchemaTypeEnum.Plate;
          then plateHoleTemplate;
          else edgeHoleTemplate
        ">
      </ng-container>

      <ng-template #plateHoleTemplate>
        <csl-plate-hole-form
          #holeForm
          [side]="side"
          (formChanged)="holeFormChanged($event)"
          [selectedMultiSide]="selectedMultiSide"
          [point]="selectedPoint"
          [availablePlate]="availablePlate"
          [fullMaterialThickness]="fullMaterialThickness"
          [panelHeight]="panel.height"
          [panelWidth]="panel.width"
          *ngIf="data && fastener"
          [data]="data"
          [fastener]="fastener"
          class="flex-1">
        </csl-plate-hole-form>
      </ng-template>
      <ng-template #edgeHoleTemplate>
        <csl-edge-hole-form
          #holeForm
          (formChanged)="holeFormChanged($event)"
          [side]="side"
          [availablePlate]="availablePlate"
          [selectedMultiSide]="selectedMultiSide"
          [point]="selectedPoint"
          [panelHeight]="panel.height"
          [panelWidth]="panel.width"
          *ngIf="data && fastener"
          [data]="data"
          [fastener]="fastener">
        </csl-edge-hole-form>
      </ng-template>
    </div>

    <div class="flex-auto overflow-auto flex flex-col">
      <div class="flex-1 flex items-center justify-center">
        <csl-svg-workspace
          class="m-auto w-fit block"
          #svgWorkspace
          [p]="panel"
          [basePointSelectMode]="true"
          [sideBasePoints]="side"
          (selectBasePoint)="setBasePoint($event)">
        </csl-svg-workspace>
      </div>

      <div class="flex flex-wrap items-center justify-center gap-4 mt-auto pt-4 pb-2">
        <div class="flex items-center gap-1">
          <svg width="24" height="24" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            <path
              class="c-hole-face through custom-hole"
              d="M13.183333333333334 12.5 a3.8166666666666664 3.8166666666666664 0 1 0 7.633333333333333 0 a3.8166666666666664 3.8166666666666664 0 1 0 -7.633333333333333 0"
              stroke="black"
              fill="white"
              stroke-width="1px"></path>
          </svg>
          <span class="text-sm text-gray-600">— сквозное отверстие</span>
        </div>

        <div class="flex items-center gap-1">
          <svg width="24" height="24" viewBox="0 0 30 25" xmlns="http://www.w3.org/2000/svg">
            <path
              class="c-hole-back custom-hole"
              d="M17.133333333333336 12.5 a6 6 0 1 0 12 0 a6 6 0 1 0 -12 0"
              stroke="none"
              fill="#863600"></path>
          </svg>
          <span class="text-sm text-gray-600">— глухое отверстие лицевая сторона</span>
        </div>

        <div class="flex items-center gap-1">
          <svg width="24" height="24" viewBox="0 0 30 25" xmlns="http://www.w3.org/2000/svg">
            <path
              class="c-hole-back custom-hole"
              d="M17.133333333333336 12.5 a6 6 0 1 0 12 0 a6 6 0 1 0 -12 0"
              stroke="none"
              fill="#a0a0a0"></path>
          </svg>
          <span class="text-sm text-gray-600">— глухое отверстие обратная сторона</span>
        </div>
      </div>
    </div>
  </div>
</div>
